import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { CommonService } from '../services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslationService } from '../services/translation.service';

@Component({
  selector: 'app-verifyemail',
  templateUrl: './verifyemail.page.html',
  styleUrls: ['./verifyemail.page.scss'],
})
export class VerifyemailPage implements OnInit {

  activationId: any = ''
  locale: any = ''

  constructor(private formBuilder: FormBuilder, private location: Location, private _apiService: ApiService, public _commonService: CommonService, private route: ActivatedRoute, private router: Router, private _translationService: TranslationService) { }

  ngOnInit() {
    this._commonService.isLoggedIn = false
  }

  ionViewWillEnter(){
    
  }

  ionViewDidEnter(){
    this.activationId = this.route.snapshot.paramMap.get('id');
    if (localStorage.locale) {
      this._commonService.locale = Number(localStorage.locale);
      this.locale = Number(localStorage.locale);
    } else {
      this._commonService.locale = 1043;
      localStorage.locale = this._commonService.locale;
    }
    

    this.verifyEmail()
  }

 async verifyEmail(){
    this._commonService.presentLoading();
    try {
      let data = {
        "ActivationId" :   this.activationId
      }
      let res = await this._apiService.verifyEmail(data);
      if(res){
        if (Number(res.DefaultPassword)) {
          let locale = localStorage.locale;
          localStorage.clear();
          sessionStorage.clear();
          localStorage.locale = locale;
          localStorage.domainName = 'master'; //f.value.domain.trim();
          this._commonService.tempUserName = localStorage.userName;
          this._commonService.tempDomainName = 'master'; //f.value.domain.trim();
          this._commonService.tempAuthKey = res.AuthenticationKey;
          this._commonService.tempDefaultPassword = true;
          this._commonService.dismiss();
          this.router.navigate(['/resetdefaultpassword']);
        }  else{
          if (res.OTPVerification) {
            this._commonService.tempUserName = localStorage.userName;
            this._commonService.tempDomainName = 'master'; //f.value.domain.trim();
            if(res.SecretKey){
              this._commonService.secretKey = res.SecretKey 
              this._commonService.showQrScanner = true
            }else{
              this._commonService.showQrScanner = false
            }
            
            this._commonService.dismiss();
            this.router.navigate(['/loginverification']);
          } else {

            let currentTime = new Date();
            localStorage.sessionStartTime = currentTime.getHours();
            localStorage.setItem('userId', res.UserId);
            localStorage.setItem('userName', res.UserName);
            localStorage.setItem('firstName', res.FirstName);
            localStorage.setItem('domainLocales', JSON.stringify(res.Locales));
            localStorage.setItem('menuItems', JSON.stringify(res.MenuItems));
            localStorage.setItem('domainName', res.DomainName);
            localStorage.setItem('domainId', res.DomainId);
            localStorage.setItem('roleCode', res.RoleCode);
            localStorage.setItem('authenticationKey', res.AuthenticationKey);
            localStorage.setItem('folderEntryAllowed', res.FolderEntryAllowed);
            localStorage.setItem('MaxAllowedCompanyPerDomain', res.MaxAllowedCompanyPerDomain);
            localStorage.setItem('helpImageChangeInterval', res.HelpImageChangeInterval);
            localStorage.setItem('notificationsUnreadCount', res.NotificationsUnreadCount ? res.NotificationsUnreadCount : 0);
            localStorage.setItem('Datecreated', res.Datecreated ? res.Datecreated : '');
            localStorage.setItem('FirstLogin', res.FirstLogin ? res.FirstLogin : 'false');
            localStorage.setItem('TeamLeaderGuid',res.TeamLeaderGuid);
            localStorage.setItem('locale',res.DefaultLocale?res.DefaultLocale:1043);
            this.locale = res.DefaultLocale?res.DefaultLocale:1043;

            this._commonService.notificationsUnreadCount = res.NotificationsUnreadCount ? res.NotificationsUnreadCount : 0

            if (res.Companies) localStorage.setItem('companies', JSON.stringify(res.Companies));
            localStorage.setItem('userRoles', res.UserRoles ? JSON.stringify(res.UserRoles) : null);
            localStorage.setItem('folderEntryStatuses', res.FolderEntryStatuses ? JSON.stringify(res.FolderEntryStatuses) : null);

            this._commonService.domainLocales = res.Locales;

            if (res.Locales.length == 1) {
              this._commonService.locale = res.Locales[0].LocaleId;
              localStorage.locale = res.Locales[0].LocaleId;
            }
            this._commonService.menuItems = res.MenuItems;
            this._commonService.domainName = res.DomainName;

            this._commonService.domain = {
              DomainId: res.DomainId,
              Name: res.DomainName
            }
            this._commonService.dismiss();

            this._translationService.getTranslation(this.locale);

            if(res.RoleCode == 'UserRole_CustomerAdmin'){
              this._commonService.isCustomerAdmin = true
            }
            if(res.RoleCode == 'UserRole_CustomerUser'){
              this._commonService.isCustomerUser = true
            }
            if(res.RoleCode == 'UserRole_Support'){
              this._commonService.isSupportUser = true
            }
            if(res.RoleCode  == 'UserRole_Legal'){
              this._commonService.isJuristUser = true
            }
            this._commonService.getFAQS()
            if (this._commonService.redirectURL) {
              let url = this._commonService.redirectURL.split('/');
              this._commonService.redirectURL = null;
              this.router.navigate(['documentlibrary/' + url[2] + '/' + url[3] + '/' + url[4]]);
            }
            else if (res.RoleCode == 'UserRole_Administrator') {
              this._commonService.isAdmin = true
              this.router.navigate(['/maintenance']);
              this._commonService.redirectURL = null;
            }
            else {this.router.navigate(['/dashboard'])
            this._commonService.redirectURL = null;
            }

            this._commonService.isLoggedIn = true;
            localStorage.domains = res.LinkedDomains ? JSON.stringify(res.LinkedDomains) : null;
          }
        }
      }
    } catch (error) {
       this._commonService.dismiss();
       this.router.navigate(['/login']);

      this._commonService.log(error, this._commonService.ERROR)
    }
  }

}
